import update from 'immutability-helper';
import { createReducer } from '../../utils/redux/reducers.utils';
import { getParentIdByPath } from '../../utils/Utils';
import {
  AUTH_LOGOUT,
  INITIAL_STATE,
  LAB_CREATE_CATEGORY,
  LAB_CREATE_ITEM,
  LAB_DELETE_CATEGORY,
  LAB_DELETE_ITEM,
  LAB_UPDATE_CATEGORY,
  LAB_UPDATE_CONTENT,
  LAB_UPDATE_ITEM,
  LAB_UPDATE_SUBCATEGORIES,
  LAB_USE_CACHE,
  APPLICATION_WIPE_DATA,
  LAB_UPDATE_ITEMS_ORDER,
} from '../actions';

const initialState = {
  items: null,
  itemsById: null,
  categories: null,
  categoriesById: null,
  lastUpdated: null,
  previousLastUpdated: null,
  isReady: false,
};

const updateLab = (state, { items, itemsById, categories, categoriesById }) =>
  update(state, {
    $merge: {
      items,
      itemsById,
      categories,
      categoriesById,
      lastUpdated: Date.now(),
      previousLastUpdated: state.lastUpdated || Date.now(),
      isReady: true,
    },
  });

const updateCategory = (state, change) => {
  let { id } = change;
  let index = state.categories.findIndex(category => category.id === id);

  return update(state, {
    categories: {
      [index]: { $merge: change },
    },
    categoriesById: {
      [id]: { $merge: change },
    },
    lastUpdated: { $set: Date.now() },
  });
};

const deleteCategory = (state, { id }) => {
  let index = state.categories.findIndex(category => category.id === id);
  let cat = state.categoriesById[id];

  let parentId = getParentIdByPath(cat.path);

  let updateAction = {
    categories: { $splice: [[index, 1]] },
    categoriesById: {
      $apply: function (obj) {
        delete obj[id];
        return obj;
      },
    },
    lastUpdated: { $set: Date.now() },
  };

  if (parentId) {
    let indexParent = state.categories.findIndex(category => category.id === parentId);
    let currentIndex = state.categories[indexParent].subcategories.findIndex(i => i === id);
    let action = {
      subcategories: {
        $splice: [[currentIndex, 1]],
      },
    };

    updateAction.categories[indexParent] = action;
    updateAction.categoriesById[parentId] = action;
  }

  return update(state, updateAction);
};

const createCategory = (state, { path, category }) => {
  let parentId = getParentIdByPath(path);

  let updateAction = {
    categories: {
      $push: [category],
    },
    categoriesById: {
      [category.id]: { $set: category },
    },
    lastUpdated: { $set: Date.now() },
  };

  if (parentId) {
    let indexParent = state.categories.findIndex(category => category.id === parentId);
    let action = {
      subcategories: { $push: [category.id] },
    };
    updateAction.categories[indexParent] = action;
    updateAction.categoriesById[parentId] = action;
  }

  return update(state, updateAction);
};

const updateSubcategories = (state, { id, categoryId, index }) => {
  let catIndex = state.categories.findIndex(category => category.id === id);
  let currentIndex = state.categories[catIndex].subcategories.findIndex(i => i === categoryId);
  let item = state.categories[catIndex].subcategories[currentIndex];

  return update(state, {
    categories: {
      [catIndex]: {
        subcategories: {
          $splice: [
            [currentIndex, 1],
            [index, 0, item],
          ],
        },
      },
    },
    categoriesById: {
      [id]: {
        subcategories: {
          $splice: [
            [currentIndex, 1],
            [index, 0, item],
          ],
        },
      },
    },

    lastUpdated: { $set: Date.now() },
  });
};

const updateItemsOrder = (state, { id, itemId, index }) => {
  let catIndex = state.categories.findIndex(category => category.id === id);
  let currentIndex = state.categories[catIndex].values.findIndex(i => i === itemId);
  let item = state.categories[catIndex].values[currentIndex];

  return update(state, {
    categories: {
      [catIndex]: {
        values: {
          $splice: [
            [currentIndex, 1],
            [index, 0, item],
          ],
        },
      },
    },
    categoriesById: {
      [id]: {
        values: {
          $splice: [
            [currentIndex, 1],
            [index, 0, item],
          ],
        },
      },
    },

    lastUpdated: { $set: Date.now() },
  });
};

const createItem = (state, { item, categoryId }) => {
  let index = state.categories.findIndex(category => category.id === categoryId);

  return update(state, {
    items: { $push: [item] },
    itemsById: {
      [item.id]: { $set: item },
    },
    categories: {
      [index]: { values: { $push: [item.id] } },
    },
    categoriesById: {
      [categoryId]: { values: { $push: [item.id] } },
    },
    lastUpdated: { $set: Date.now() },
  });
};

const updateItem = (state, { item }) => {
  let index = state.items.findIndex(i => i.id === item.id);

  return update(state, {
    items: { [index]: { $merge: item } },
    itemsById: {
      [item.id]: { $set: item },
    },
    lastUpdated: { $set: Date.now() },
  });
};

const deleteItem = (state, { id }) => {
  let index = state.items.findIndex(i => i.id === id);

  return update(state, {
    items: { $splice: [[index, 1]] },
    itemsById: {
      $apply: function (obj) {
        delete obj[id];
        return obj;
      },
    },
    lastUpdated: { $set: Date.now() },
  });
};

const useCache = state =>
  update(state, {
    isReady: { $set: true },
  });

const setInitialState = (state, { lab = initialState }) =>
  update(state, {
    $merge: {
      ...lab,
      isReady: false,
    },
  });

const cleanData = (state, payload) => {
  return initialState;
};

const actionsRepo = {
  [INITIAL_STATE]: setInitialState,
  [LAB_UPDATE_CONTENT]: updateLab,
  [LAB_UPDATE_CATEGORY]: updateCategory,
  [LAB_DELETE_CATEGORY]: deleteCategory,
  [LAB_CREATE_CATEGORY]: createCategory,
  [LAB_UPDATE_SUBCATEGORIES]: updateSubcategories,
  [LAB_CREATE_ITEM]: createItem,
  [LAB_UPDATE_ITEM]: updateItem,
  [LAB_DELETE_ITEM]: deleteItem,
  [LAB_UPDATE_ITEMS_ORDER]: updateItemsOrder,
  [LAB_USE_CACHE]: useCache,
  [APPLICATION_WIPE_DATA]: cleanData,
  [AUTH_LOGOUT]: cleanData,
};

export default createReducer({ initialState, actionsRepo });
